import { useEffect } from 'react';
import { connect, Dispatch } from 'react-redux';
import { IBaseResponse, IOptnRegion, IState } from '@nkr/models/index';
import { AppActionCreators, BillingActionCreators, IApplicationState, IOpoAddUpdateRequest, IOpoResponse, IValidateAchRoutingNumberResponse, OpoActionCreators } from '@nkr/store/index';
import { Alert, Button, Modal } from 'react-bootstrap'
import { IAddEditState, initialState } from './add-edit-state';
import { FormProvider, useForm } from 'react-hook-form';
import { AddEditFormWrapper } from '../list/styles';
import OpoContent from './content';
import usePrevious from '@nkr/services/use-previous';

interface IProps {
    show: boolean,
    id: number,
    stateList: IState[],
    optnRegionList: IOptnRegion[],
    onSaveComplete: (id: number, alias: string, name: string, city: string, state: string, isActive: boolean, achApproved: boolean) => void,
    onCancel: () => void
}

interface IStateProps {
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getById: (id: number) => Promise<IOpoResponse>,
    update: (id: number, request: IOpoAddUpdateRequest) => Promise<IBaseResponse>,
    validateAchRoutingNumber: (achRoutingNumber: string) => Promise<IValidateAchRoutingNumberResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

const Edit = (props: TProps) => {
    const methods = useForm<IAddEditState>({ defaultValues: initialState, mode: 'onSubmit' });
    const { handleSubmit, reset, watch, formState: { isValid, isSubmitted } } = methods;

    const formData = watch();

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show == true) {
            props.showLoading('Getting OPO information, one moment please...').then(() => {
                props.getById(props.id)
                    .then(response => {
                        if (response.data.success) {
                            reset(response.data.results);
                        }
                    })
                    .catch(error => {

                    })
                    .finally(() => {
                        props.hideLoading();
                    });
            })
        }
    }, [props.show]);

    const handleSave = () => {
        props.showLoading('Saving OPO information, one moment please...').then(() => {
            props.update(props.id, formData)
                .then(response => {
                    if (response.data.success) {
                        let { optnAlias, optnName, city, stateId, isActive, achApproved } = formData;

                        let state = props.stateList.find(x=>x.id == stateId);

                        props.onSaveComplete(props.id, optnAlias, optnName, city, state.abbreviation, isActive, achApproved);
                    }
                })
                .catch(error => {
                    console.log(error)
                })
                .finally(() => {
                    props.hideLoading();
                });
        });
    };

    return (
        <Modal backdrop='static' bsSize='lg' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Update OPO</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isSubmitted && !isValid && (
                    <Alert bsStyle='danger' bsSize='sm'>The items in red are required to continue...</Alert>
                )}

                <FormProvider {...methods}>
                    <AddEditFormWrapper horizontal onSubmit={handleSubmit(handleSave)}>
                        <OpoContent
                            isOpo={false}
                            stateList={props.stateList}
                            optnRegionList={props.optnRegionList}
                            validateAchRoutingNumber={props.validateAchRoutingNumber}
                        />
                    </AddEditFormWrapper>
                </FormProvider>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleSubmit(handleSave)}>Save OPO</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getById: (id) => {
            return dispatch(OpoActionCreators.getById(id));
        },
        update: (id, request) => {
            return dispatch(OpoActionCreators.update(id, false, request));
        },
        validateAchRoutingNumber: (achRoutingNumber) => {
            return dispatch(BillingActionCreators.validateAchRoutingNumber(achRoutingNumber));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(Edit);